import { NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/home', icon: 'potted_plant', label: 'Plants' },
  { to: '/add', icon: 'center_focus_strong', label: 'Scan' },
  { to: '/activity', icon: 'timeline', label: 'Activity' },
  { to: '/settings', icon: 'person', label: 'Me' },
];

export function BottomNav() {
  const location = useLocation();

  // Hide on login page
  if (location.pathname === '/login') return null;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-background/95 backdrop-blur-sm safe-bottom"
      aria-label="Main navigation"
    >
      <div className="mx-auto flex max-w-md items-center justify-around px-2 pb-2 pt-2">
        {navItems.map((item, index) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex min-w-[64px] flex-col items-center gap-1 py-1 transition-colors ${
                isActive
                  ? 'text-primary'
                  : 'text-gray-400 hover:text-editorial-black'
              }${index === 2 ? ' border-l border-gray-200' : ''}`
            }
            aria-label={item.label}
          >
            {({ isActive }) => (
              <>
                <span
                  className={`material-symbols-outlined ${isActive ? 'filled' : ''}`}
                  style={{ fontSize: 24 }}
                  aria-hidden="true"
                >
                  {item.icon}
                </span>
                <span className="font-sans text-[10px] font-medium uppercase tracking-widest">
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
